import React from 'react';
import { Tree, Icon } from 'antd';

const SvgComponent = props => (
  <svg width="1em" height="1em" viewBox="0 0 48 48" {...props}>
    <rect x="16" y="16" width="16" height="16" fill="currentColor" />
  </svg>
);

class CustomTree extends Tree {
  renderSwitcherIcon = ({ isLeaf, expanded, loading }) => {
    const {
      prefixCls,
      showLine,
    } = this.props;

    if (loading) {
      return (
        <Icon
          type="loading"
          className={`${prefixCls}-switcher-loading-icon`}
        />
      );
    }
    if (showLine) {
      if (isLeaf) {
        return (
          <Icon
            component={SvgComponent}
            className={`${prefixCls}-switcher-line-icon`}
          />
        );
      }
      return (
        <Icon
          type={expanded ? 'minus-square' : 'plus-square'}
          className={`${prefixCls}-switcher-line-icon`}
          theme="outlined"
        />
      );
    } else {
      if (isLeaf) {
        return null;
      }
      return (
        <Icon type="caret-down" className={`${prefixCls}-switcher-icon`} theme="filled" />
      );
    }
  }
}

export default CustomTree;
